import React from 'react';
import styled from '@emotion/styled';
import { Image } from 'views/components/atoms/Image';
import { Typography } from 'views/components/atoms/Typography';
import { Color, FontSize, MAX_WIDTH } from 'views/constants';
import { Icon } from 'views/components/molecules/Icon';
import { FormattedDate, FormattedTime } from 'react-intl';
import { TableLink } from 'views/components/atoms/TableLink';

const Wrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
`;

const ImageWrapper = styled.div`
  width: 32px;
  height: 32px;
`;

const Details = styled.div`
  /* 右側の矢印アイコンと文字が被らないように36px間を開ける */
  margin: 0 36px 0 8px;
  flex: 1;
  overflow: hidden;
  word-break: break-all;

  > :not(:first-of-type) {
    margin-top: 2px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;

  > :not(:first-of-type) {
    margin-left: 6px;
  }
`;

const ApplicationNameWrapper = styled.div`
  display: flex;
  overflow: hidden;

  > :not(:first-of-type) {
    margin-left: 6px;
  }

  & > span:first-of-type {
    flex: 1;
  }
`;

interface AppListProps {
  to: string;
  iconSrc: string;
  title: string;
  version: string;
  ownerName: string;
  bundleIdentifier: string;
  revision: number;
  updatedAt: Date;
  message?: string;
  distributionName?: string;
}

export const AppLink: React.FC<AppListProps> = ({
  to,
  iconSrc,
  title,
  version,
  ownerName,
  bundleIdentifier,
  revision,
  updatedAt,
  message,
  distributionName,
}) => (
  <Wrapper>
    <TableLink to={to}>
      <ImageWrapper>
        <Image src={iconSrc} alt={title} />
      </ImageWrapper>
      <Details>
        <TitleWrapper>
          {distributionName ? <Icon type="distribution" size="small" /> : null}
          <ApplicationNameWrapper>
            <Typography size={FontSize.S} ellipsis>
              {title}
            </Typography>
            <Typography size={FontSize.S} color={Color.C3}>
              {`#${revision}`}
            </Typography>
          </ApplicationNameWrapper>
        </TitleWrapper>
        {/* bundle identifier を ellipsis すると区別がつかないので、諦めて折り返す */}
        <Typography size={FontSize.S} preWrap>
          {bundleIdentifier}
        </Typography>
        <Typography size={FontSize.S} color={Color.C3} block ellipsis>
          {distributionName ? 'via ' + distributionName : 'by ' + ownerName}
        </Typography>
        <Typography size={FontSize.S} color={Color.C3} block>
          {version}
        </Typography>
        {message ? (
          <Typography size={FontSize.S} color={Color.C3} block ellipsis>
            {message}
          </Typography>
        ) : null}
        <Typography size={FontSize.S} color={Color.C3} block>
          {<FormattedDate value={updatedAt} format="default" />}{' '}
          {<FormattedTime value={updatedAt} format="default" />}
        </Typography>
      </Details>
    </TableLink>
  </Wrapper>
);
